// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__kVQAt","title":"ClientReferral_title__3yRDD","itemText":"ClientReferral_itemText__31aSD"};